import React from "react";

import Applet from "../../Applet";
import DocumentTypeTable from "../../../../components/IntegrationTemplate/DocumentTypeTable";

class DocumentTypeTableApplet extends Applet {

    render() {
        return <DocumentTypeTable applet={this}
                               pageSize={this.state.PageSize}
                               placement={this.state.Placement}
                               columns={this.state.Columns}
                               title="Document Types"
                               enterpriseComponent={this.getEnterpriseComponent()}
                               sort={this.state.Sort}
                               menu={this.state.Menu}
                               rowHeight={this.state.RowHeight}
                               enableSort={true}
                               enableDefaultSort={false}
        />;
    }

    state = {
        Name: "DocumentTypeTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 10,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Group",
                },
                {
                    id: "DocumentTypeAcronym",
                },
                {
                    id: "DocumentTypeName",
                },
                {
                    id: "USID",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "DocumentTypeName",
                width: 250,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "DocumentTypeAcronym",
                width: 150,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Acronym",
            },
            {
                id: "Group",
                width: 250,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Group",
            },
            {
                id: "USID",
                width: 300,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "USID",
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "DocumentTypeAcronym",
                    "DisplayName": "Acronym",
                }]
            },
            {
                "Identifier": 3,
                "Visible": true,
                "Default": false,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "DocumentTypeName",
                    "DisplayName": "Name",
                }]
            }
        ]
    };
}

export default DocumentTypeTableApplet;
